import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NbButtonModule, NbIconModule } from '@nebular/theme';

/**
 * Estado vazio de listagem (`TAB-12`), num lugar só.
 *
 * Duas situações que a tela precisa separar, e que antes se confundiam num `<p>` só:
 *
 * - **não há registro** — explica e oferece o atalho para criar;
 * - **o recorte escondeu** — diz que há filtro aplicado e oferece "ver todos".
 *
 * Dizer "nenhum X com o filtro atual" para quem não filtrou nada manda a pessoa procurar um
 * filtro que ela não aplicou; e lista vazia sem explicação é lida como "não existe", e aí
 * alguém cadastra de novo o que já estava lá.
 *
 * O `icone` é o mesmo do item de menu que leva à tela (`NAV-06`): é o que confirma, ao
 * chegar numa tela vazia, que se chegou onde se queria.
 */
@Component({
  selector: 'app-lista-vazia',
  standalone: true,
  imports: [CommonModule, NbIconModule, NbButtonModule],
  templateUrl: './lista-vazia.component.html',
  styleUrl: './lista-vazia.component.scss',
})
export class ListaVaziaComponent {
  /** Ícone do item de menu desta tela (`NAV-06`). */
  @Input({ required: true }) icone = '';

  /** Verdadeiro quando há filtro, busca ou recorte de outra tela em vigor. */
  @Input() filtrado = false;

  /** Frase de "não há nenhum registro ainda". */
  @Input({ required: true }) mensagem = '';

  /** Frase de "há registros, mas o recorte atual não casou com nenhum". */
  @Input() mensagemFiltrado = 'Nenhum registro com o recorte atual.';

  /** Rótulo do atalho de criar. Vazio esconde o botão — telas sem criação direta. */
  @Input() acaoCriarRotulo = '';

  @Output() criar = new EventEmitter<void>();

  /** Emitido quando a pessoa pede para limpar o recorte e ver tudo. */
  @Output() verTodos = new EventEmitter<void>();
}
